'use client'
import { LinkExternal } from '@/types/common/LinkExternal'
import s from './Filter.module.scss'
import { motion } from 'framer-motion'
import { useContext, useEffect, useState } from 'react'
import Link from 'next/link'
import React from 'react'
import LazyImage from '@/components/common/LazyImage'
import { Status, Region, Typology } from '@/types/singles/category'
import { Image } from '@/types/common/ImageData'

interface DataProps {
    typologies: Array<Typology>;
    status: Array<Status>;
    regions: Array<Region>;
    onFilterChange: (filters: { typologies: string[], status: string[], regions: string[] }) => void;
    filterStatus: Array<string>;
    filterRegion: Array<string>;
    filterTypology: Array<string>;
    selectedDisplay: string;
    setSelectedDisplay: (display: string) => void;
}

export default function ProjectsFilterComponent({
    typologies, 
    status, 
    regions, 
    onFilterChange,
    filterStatus,
    filterRegion,
    filterTypology,
    selectedDisplay,
    setSelectedDisplay
}: DataProps) {

    const [selectedFilters, setSelectedFilters] = useState<{ typologies: string[], status: string[], regions: string[] }>({
        typologies: filterTypology,
        status: filterStatus,
        regions: filterRegion
    });
    const [openFilters, setOpenFilters] = useState(false);

    const [isMobile, setIsMobile] = useState(false);
        
    // Detectar si es mobile o desktop
    useEffect(() => {
        const checkScreenSize = () => setIsMobile(window.innerWidth < 768);
        checkScreenSize();
        window.addEventListener("resize", checkScreenSize);
        
        return () => window.removeEventListener("resize", checkScreenSize);
    }, []);

    useEffect(() => {
        if (openFilters && isMobile) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }
    }, [openFilters]);

    const handleCheckboxChange = (category: 'typologies' | 'status' | 'regions', value: string) => {
        setSelectedFilters(prevFilters => {
            let updatedCategory = prevFilters[category];
    
            if (value === "ALL") {
                // Si se selecciona "ALL", solo dejamos "ALL" en la categoría
                updatedCategory = ["ALL"];
            } else {
                // Si la opción ya estaba seleccionada, la quitamos
                if (updatedCategory.includes(value)) {
                    updatedCategory = updatedCategory.filter(item => item !== value);
                } else {
                    // Si "ALL" estaba seleccionado y se elige otra opción, lo eliminamos
                    updatedCategory = updatedCategory.filter(item => item !== "ALL");
                    updatedCategory.push(value);
                }
            }
    
            // Si la lista queda vacía, volvemos a poner "ALL"
            if (updatedCategory.length === 0) {
                updatedCategory = ["ALL"];
            }
    
            const newFilters = { ...prevFilters, [category]: updatedCategory };
            onFilterChange(newFilters);
            return newFilters;
        });
    };
    

    return (
        <div className={s.filterListPadding}>
        <div className={s.filterList}>
            <div className={s.filterHeader}>
                <div className={s.buttons}>
                    <button onClick={() => setOpenFilters(!openFilters)}>FILTERS 
                        <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.16049 7.19141C7.43664 7.19141 7.66049 6.96755 7.66049 6.69141L7.66049 2.19141C7.66049 1.91526 7.43664 1.69141 7.16049 1.69141C6.88435 1.69141 6.66049 1.91526 6.66049 2.19141L6.66049 6.19141L2.66049 6.19141C2.38435 6.19141 2.16049 6.41526 2.16049 6.69141C2.16049 6.96755 2.38435 7.19141 2.66049 7.19141L7.16049 7.19141ZM0.482384 0.720405L6.80694 7.04496L7.51405 6.33785L1.18949 0.0132984L0.482384 0.720405Z" fill="#0A0A0A"/>
                            <path d="M7.16049 7.19141C7.43664 7.19141 7.66049 6.96755 7.66049 6.69141L7.66049 2.19141C7.66049 1.91526 7.43664 1.69141 7.16049 1.69141C6.88435 1.69141 6.66049 1.91526 6.66049 2.19141L6.66049 6.19141L2.66049 6.19141C2.38435 6.19141 2.16049 6.41526 2.16049 6.69141C2.16049 6.96755 2.38435 7.19141 2.66049 7.19141L7.16049 7.19141ZM0.482384 0.720405L6.80694 7.04496L7.51405 6.33785L1.18949 0.0132984L0.482384 0.720405Z" fill="#0A0A0A" fillOpacity="0.2"/>
                            <path d="M7.16049 7.19141C7.43664 7.19141 7.66049 6.96755 7.66049 6.69141L7.66049 2.19141C7.66049 1.91526 7.43664 1.69141 7.16049 1.69141C6.88435 1.69141 6.66049 1.91526 6.66049 2.19141L6.66049 6.19141L2.66049 6.19141C2.38435 6.19141 2.16049 6.41526 2.16049 6.69141C2.16049 6.96755 2.38435 7.19141 2.66049 7.19141L7.16049 7.19141ZM0.482384 0.720405L6.80694 7.04496L7.51405 6.33785L1.18949 0.0132984L0.482384 0.720405Z" fill="#0A0A0A" fillOpacity="0.2"/>
                            <path d="M7.16049 7.19141C7.43664 7.19141 7.66049 6.96755 7.66049 6.69141L7.66049 2.19141C7.66049 1.91526 7.43664 1.69141 7.16049 1.69141C6.88435 1.69141 6.66049 1.91526 6.66049 2.19141L6.66049 6.19141L2.66049 6.19141C2.38435 6.19141 2.16049 6.41526 2.16049 6.69141C2.16049 6.96755 2.38435 7.19141 2.66049 7.19141L7.16049 7.19141ZM0.482384 0.720405L6.80694 7.04496L7.51405 6.33785L1.18949 0.0132984L0.482384 0.720405Z" fill="#0A0A0A" fillOpacity="0.2"/>
                        </svg>
                    </button>
                    {!selectedFilters.typologies.includes('ALL') || !selectedFilters.status.includes('ALL') || !selectedFilters.regions.includes('ALL') ?
                    <button onClick={() => {
                        onFilterChange({ typologies: ['ALL'], status: ['ALL'], regions: ['ALL'] });
                        setSelectedFilters({ typologies: ['ALL'], status: ['ALL'], regions: ['ALL'] });
                        
                    }}>
                        CLEAR FILTERS
                    </button> : undefined
                    }
                </div>
                
                <div className={s.listGrid}>
                    <button className={s.grid}
                        onClick={() => {setSelectedDisplay('grid'); window.scrollTo({ top: 0 }); setOpenFilters(false)}}
                    >
                        <svg width="11" height="13" viewBox="0 0 11 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect y="0.0175781" width="4.71429" height="5.7619" fill={selectedDisplay == 'grid' ? '#0a0a0a': '#B7B3A8'}/>
                            <rect x="5.89062" y="0.0175781" width="4.71429" height="5.7619" fill={selectedDisplay == 'grid' ? '#0a0a0a': '#B7B3A8'}/>
                            <rect y="7.21996" width="4.71429" height="5.7619" fill={selectedDisplay == 'grid' ? '#0a0a0a': '#B7B3A8'}/>
                            <rect x="5.89062" y="7.21996" width="4.71429" height="5.7619" fill={selectedDisplay == 'grid' ? '#0a0a0a': '#B7B3A8'}/>
                        </svg>
                    </button>
                    <button className={s.list}
                        onClick={() => {setSelectedDisplay('list'); window.scrollTo({ top: 0 }); setOpenFilters(false)}}
                    >
                        <svg width="11" height="13" viewBox="0 0 11 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="0.28125" y="0.0175781" width="10.6071" height="2.35714" fill={selectedDisplay == 'list' ? '#0a0a0a': '#B7B3A8'}/>
                            <rect x="0.28125" y="0.0175781" width="10.6071" height="2.35714" fill={selectedDisplay == 'list' ? '#0a0a0a': '#B7B3A8'} fillOpacity="0.2"/>
                            <rect x="0.28125" y="0.0175781" width="10.6071" height="2.35714" fill={selectedDisplay == 'list' ? '#0a0a0a': '#B7B3A8'} fillOpacity="0.2"/>
                            <rect x="0.28125" y="0.0175781" width="10.6071" height="2.35714" fill={selectedDisplay == 'list' ? '#0a0a0a': '#B7B3A8'} fillOpacity="0.2"/>
                            <rect x="0.28125" y="3.5533" width="10.6071" height="2.35714" fill={selectedDisplay == 'list' ? '#0a0a0a': '#B7B3A8'}/>
                            <rect x="0.28125" y="3.5533" width="10.6071" height="2.35714" fill={selectedDisplay == 'list' ? '#0a0a0a': '#B7B3A8'} fillOpacity="0.2"/>
                            <rect x="0.28125" y="3.5533" width="10.6071" height="2.35714" fill={selectedDisplay == 'list' ? '#0a0a0a': '#B7B3A8'} fillOpacity="0.2"/>
                            <rect x="0.28125" y="3.5533" width="10.6071" height="2.35714" fill={selectedDisplay == 'list' ? '#0a0a0a': '#B7B3A8'} fillOpacity="0.2"/>
                            <rect x="0.28125" y="7.089" width="10.6071" height="2.35714" fill={selectedDisplay == 'list' ? '#0a0a0a': '#B7B3A8'}/>
                            <rect x="0.28125" y="7.089" width="10.6071" height="2.35714" fill={selectedDisplay == 'list' ? '#0a0a0a': '#B7B3A8'} fillOpacity="0.2"/>
                            <rect x="0.28125" y="7.089" width="10.6071" height="2.35714" fill={selectedDisplay == 'list' ? '#0a0a0a': '#B7B3A8'} fillOpacity="0.2"/>
                            <rect x="0.28125" y="7.089" width="10.6071" height="2.35714" fill={selectedDisplay == 'list' ? '#0a0a0a': '#B7B3A8'} fillOpacity="0.2"/>
                            <rect x="0.28125" y="10.6247" width="10.6071" height="2.35714" fill={selectedDisplay == 'list' ? '#0a0a0a': '#B7B3A8'}/>
                            <rect x="0.28125" y="10.6247" width="10.6071" height="2.35714" fill={selectedDisplay == 'list' ? '#0a0a0a': '#B7B3A8'} fillOpacity="0.2"/>
                            <rect x="0.28125" y="10.6247" width="10.6071" height="2.35714" fill={selectedDisplay == 'list' ? '#0a0a0a': '#B7B3A8'} fillOpacity="0.2"/>
                            <rect x="0.28125" y="10.6247" width="10.6071" height="2.35714" fill={selectedDisplay == 'list' ? '#0a0a0a': '#B7B3A8'} fillOpacity="0.2"/>
                        </svg>
                    </button>
                </div>
            </div>
            {openFilters && (
            <motion.div className={`${s.filtering}`}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.3 }}

            >
                <div className={s.filterGroup}>
                    <h4>Typologies</h4>
                    <div className={s.allFilters}>
                    <label className={s.checkboxLabel}>
                        <input
                            type="checkbox"
                            value="ALL"
                            checked={selectedFilters.typologies.includes("ALL")}
                            onChange={() => handleCheckboxChange('typologies', "ALL")}
                        />
                        <span className={s.checkmark}></span>
                        ALL
                    </label>
                    {typologies.map((typology, index) => (
                        <label key={index} className={s.checkboxLabel}>
                            <input
                                type="checkbox"
                                value={typology.title}
                                checked={selectedFilters.typologies.includes(typology.title)}
                                onChange={() => handleCheckboxChange('typologies', typology.title)}
                            />
                            <span className={s.checkmark}></span>
                            {typology.title}
                        </label>
                    ))}
                    </div>
                </div>

                <div className={s.filterGroup}>
                    <h4>Status</h4>
                    <div className={s.allFilters}>
                    <label className={s.checkboxLabel}>
                        <input
                            type="checkbox"
                            value="ALL"
                            checked={selectedFilters.status.includes("ALL")}
                            onChange={() => handleCheckboxChange('status', "ALL")}
                        />
                        <span className={s.checkmark}></span>
                        ALL
                    </label>
                    {status.map((statusItem, index) => (
                        <label key={index} className={s.checkboxLabel}>
                            <input
                                type="checkbox"
                                value={statusItem.title}
                                checked={selectedFilters.status.includes(statusItem.title)}
                                onChange={() => handleCheckboxChange('status', statusItem.title)}
                            />
                            <span className={s.checkmark}></span>
                            {statusItem.title}
                        </label>
                    ))}
                    </div>
                </div>

                <div className={s.filterGroup}>
                    <h4>Regions</h4>
                    <div className={s.allFilters}>
                    <label className={s.checkboxLabel}>
                        <input
                            type="checkbox"
                            value="ALL"
                            checked={selectedFilters.regions.includes("ALL")}
                            onChange={() => handleCheckboxChange('regions', "ALL")}
                        />
                        <span className={s.checkmark}></span>

                        ALL
                    </label>
                    {regions.map((region, index) => (
                        <label key={index} className={s.checkboxLabel}>
                            <input
                                type="checkbox"
                                value={region.title}
                                checked={selectedFilters.regions.includes(region.title)}
                                onChange={() => handleCheckboxChange('regions', region.title)}
                            />
                            <span className={s.checkmark}></span>
                            {region.title}
                        </label>
                    ))}
                    </div>
                </div>

                <div className={s.applyFilters}>
                {(
                    (selectedFilters.typologies.length > 0 && !selectedFilters.typologies.includes("ALL")) ||
                    (selectedFilters.status.length > 0 && !selectedFilters.status.includes("ALL")) ||
                    (selectedFilters.regions.length > 0 && !selectedFilters.regions.includes("ALL"))
                ) ? (
                    <button onClick={() => setOpenFilters(false)} className={s.buttonMobileWith}>APPLY FILTERS</button>
                ) : (
                    <button onClick={() => setOpenFilters(false)} className={s.buttonMobile}>CLOSE</button>
                )}
                </div>
            </motion.div>
            )}

        </div>
        </div>
    )
}